import { useAppDispatch, useAppSelector } from "@app/hooks"
import GenericDialog from "@cmp/genericDialog"
import { deleteProgramPopupClosed } from "@features/program/programSlice"
import {
  selectClassesForProgram,
  selectProgram,
} from "@features/program/programSliceSelectors"
import { deleteProgramConfirmed } from "@features/program/programSliceThunks"
import { formatDate } from "@masterschool/foundations"
import { domainToDisplayName } from "@utils/domainUtils"

function DeleteProgramPopup() {
  const model = useAppSelector((state) => state.program.deleteProgramPopup)
  const classes = useAppSelector(selectClassesForProgram(model?.programId))

  if (classes.length > 0) {
    return <RemoveAllClassesNeededPopup />
  } else {
    return <DeleteProgramConfirmationPopup />
  }
}

function RemoveAllClassesNeededPopup() {
  const model = useAppSelector((state) => state.program.deleteProgramPopup)
  const dispatch = useAppDispatch()
  const onClose = () => dispatch(deleteProgramPopupClosed())

  return (
    <GenericDialog
      onClose={onClose}
      open={model !== undefined}
      size="xs"
      title="Can’t delete program"
      subtitle="Remove all classes from the program to delete it."
      buttons={[
        {
          type: "primary",
          text: "Got it",
          onClick: onClose,
        },
      ]}
    />
  )
}

function DeleteProgramConfirmationPopup() {
  const model = useAppSelector((state) => state.program.deleteProgramPopup)
  const program = useAppSelector((state) =>
    selectProgram(state, model?.programId),
  )
  const dispatch = useAppDispatch()
  const onClose = () => dispatch(deleteProgramPopupClosed())
  const onConfirm = () => dispatch(deleteProgramConfirmed())

  // Name the subject so the confirm states exactly what is being deleted.
  const programName = program
    ? `${domainToDisplayName(program.domain)}, starting ${formatDate(
        new Date(program.startDate),
        { year: "numeric", month: "long", day: "numeric" },
      )}`
    : undefined

  return (
    <GenericDialog
      open={model !== undefined}
      onClose={onClose}
      title="Delete program"
      content={
        programName
          ? `You're deleting ${programName}. Deleted programs can’t be restored.`
          : "Deleted programs can’t be restored."
      }
      size="xs"
      buttons={[
        {
          type: "secondary",
          text: "Cancel",
          onClick: onClose,
        },
        {
          type: "danger",
          text: "Delete program",
          onClick: onConfirm,
        },
      ]}
    />
  )
}

export default DeleteProgramPopup
